// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3un-t","title":"Info_title__GAL4X","selects":"Info_selects__3R3qL","requiredAsterisk":"Info_requiredAsterisk__1X56_"};